import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        color: theme.palette.text.primary,
        opacity: 0.3,
      },
    }),
    [],
  );

  return styles;
};
